import React, { Profiler, useCallback, useState } from "react";
import { useEffect } from "react";
import PopUp from "../../Components/PopUp/PopUp";
import "./Index.css";
import Loader from "../../Components/Loader/Loader";
import Soal from "../../Components/Soal/Soal";
import Timer from "../../Components/Timer/Timer"
import { useContext } from "react";
import { DataContext } from '../../Contexts/ResultContext'
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../Components/Header/Header";


function Index() {
  const [data, setData] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [isShowPopUp, setIsShowPopUp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [finalTheme , setFinalTheme] = useState('');

  const navigate = useNavigate()

  const { azmoon_online_id , theme } = useParams();

  const finalThemeHandler = (theme) => {
    setFinalTheme(theme)
  }

 const navigateToResult = () => {
  navigate('/result' , {
    state : {
      defaultTheme : finalTheme,
        data : data,
       
    }
   })
 }  

  const userKeyHandler = (id , user_key) => {
    const copy_data = [...data];
    copy_data.map((item , index) => {
      if(item.id == id)
      {
        copy_data[index].user_key = user_key;
      }
    })

    setData(copy_data)
  }

  
  const isShowPopUpHandler = (status) => {
    setIsShowPopUp(status);
  };
 
  useEffect(() => {
    const param = {
      azmoon_online_id: azmoon_online_id,
    };
   
    setFinalTheme(theme)

    
    fetch(`https://my-dars.com/api/v6/get_azmoon_online_shah`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((data) => {

        data.data.map((item) => {
         item.user_key = 0;
        })
        console.log(data.data)
        setData(data.data);
        setTimer((data.time * 60));
        setIsLoad(true);
      });
  }, []);

  return (
    <DataContext.Provider value={data}>
      <div className="shah_kelid_soal">
     
        <div className="main_container">
          
          <Header defaultTheme={theme} finalThemeHandler={finalThemeHandler} ></Header>

          {!isLoad && <Loader />}
          
          {data.map((item, index) => (
            <Soal key={item.id} {...item} num={index} userKeyHandler={userKeyHandler} />
          ))}

          
          
        </div>
      </div>

      {/* <!-- Footer Block --> */}
      <footer className="footer footer_fixed">
        <div className="footer__toolbar">
          <div className="footer__timer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-8h4v2h-6V7h2v5z"></path>
            </svg>
             { (timer != 0) &&  <Timer time_count={timer} navigateToResult={navigateToResult} />}
          </div>
        </div>

        <button
          onClick={() => {
            setIsShowPopUp(true);
          }}
          className="footer__result_button"
        >
          <span className="footer__result_text">پایان آزمون</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M10.828 12l4.95 4.95-1.414 1.415L8 12l6.364-6.364 1.414 1.414-4.95 4.95z"></path>
          </svg>
        </button>
      </footer>
      {/* <!-- End Footer Block --> */}

      <PopUp isShow={isShowPopUp} popUpHandler={isShowPopUpHandler} navigateToResult={navigateToResult}>
        <span className="bold">آیا از اتمام آزمون اطمینان دارید؟</span>
      </PopUp>
    </DataContext.Provider>
  );
}

export default Index;
